import React from "react";
import Box from "../../../../common/box/Box";
import { isMobile, isDesktop } from "../../../../utils/screenUtil";
import { useTranslation } from "react-i18next";
import { Row, Column } from "../../../../common/columns";
import "./ElectionDetail.scss";

function ElectionDetail({ electionDetail, election }) {
  const { t } = useTranslation();

  return (
    <Box
      isRadiusless={isDesktop() ? true : electionDetail ? false : true}
      isBorderless={isDesktop() ? true : electionDetail ? false : true}
      statusIndicatorColor="grey"
      statusIndicatorWidth={1}
      statusIndicatorPosition="left"
      className="ml-4 mr-4 py-4 electionDetail"
      isShadowless={isDesktop() ? true : electionDetail ? false : true}
    >
      {electionDetail && (
        <Row className={"is-multiline"}>
          <Column size={10}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.electionType")}</span>
              </div>
              <div className="is-size-5">
                <span>{election?.electionType?.typeName}</span>
              </div>
            </Box>
          </Column>
          <Column size={2}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.numOfChoices")}</span>
              </div>
              <div className="is-size-5">
                <span>{election?.numberOfChoices}</span>
              </div>
            </Box>
          </Column>
          <Column size={12}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.electionDescription")}</span>
              </div>
              <div className="is-size-5">
                <span>{election?.description}</span>
              </div>
            </Box>
          </Column>
          <Column size={4}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.dateOfAnnouncement")}</span>
              </div>
              <div className="is-size-5">
                <span>{new Date(election?.dateOfAnnouncement).toLocaleDateString("hr-HR")}</span>
              </div>
            </Box>
          </Column>
          <Column size={4}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.startingTime")}</span>
              </div>
              <div className="is-size-5">
                <span>
                  {election?.dateTimeVotingStart !== null
                    ? new Date(election?.dateTimeVotingStart).toLocaleDateString("hr-HR")
                    : "-"}{" "}
                  {election?.dateTimeVotingStart !== null &&
                    new Date(election?.dateTimeVotingStart).toLocaleTimeString("hr-HR")}
                </span>
              </div>
            </Box>
          </Column>
          <Column size={4}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.endingTime")}</span>
              </div>
              <div className="is-size-5">
                <span>
                  {election?.dateTimeVotingEnd !== null
                    ? new Date(election?.dateTimeVotingEnd).toLocaleDateString("hr-HR")
                    : "-"}{" "}
                  {election?.dateTimeVotingEnd !== null &&
                    new Date(election?.dateTimeVotingEnd).toLocaleTimeString("hr-HR")}
                </span>
              </div>
            </Box>
          </Column>
          <Column size={12}>
            <Box
              isBorderless={true}
              isRadiusless={true}
              statusIndicatorColor="grey"
              statusIndicatorWidth={1}
              statusIndicatorPosition={isDesktop() ? "bottom" : ""}
              isShadowless={true}
            >
              <div className="is-size-6 ml-1 has-text-purple-dark">
                <span>{t("voting.electionDetails.location")}</span>
              </div>
              <div className="is-size-5">
                <span>{election?.location?.name}</span>
              </div>
            </Box>
          </Column>
        </Row>
      )}
    </Box>
  );
}

export default ElectionDetail;
